module.exports = __webpack_public_path__ + "static/media/Security-Kathleen-Maddan.d6a4e94a.m4v";